import { render } from "./RTV.vue?vue&type=template&id=13e4d58d&scoped=true"
import script from "./RTV.vue?vue&type=script&lang=js"
export * from "./RTV.vue?vue&type=script&lang=js"

import "./RTV.vue?vue&type=style&index=0&id=13e4d58d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e4d58d"]])

export default __exports__